(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[982],{

/***/ 48847:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"handle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"originalSrc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"altText"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":148}};
    doc.loc.source = {"body":"fragment CollectionFragment on Collection {\n  id\n  handle\n  description\n  updatedAt\n  title\n  image {\n    id\n    src: originalSrc\n    altText\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.CollectionFragment = oneQuery(doc, "CollectionFragment");
        


/***/ }),

/***/ 19053:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionsProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"reverse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reverse"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"values"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"input"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionProduct"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":467}};
    doc.loc.source = {"body":"#import \"./ProductFragment.gql\"\n\nfragment CollectionsProductFragment on Collection {\n  products(first: $first, sortKey: $sortKey, after: $after, reverse: $reverse, filters: $filters) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n    }\n    filters {\n      id\n      label\n      type\n      values {\n        count\n        id\n        label\n        input\n      }\n    }\n    edges {\n      cursor\n      node {\n        ...CollectionProduct       \n      }\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(81948).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.CollectionsProductFragment = oneQuery(doc, "CollectionsProductFragment");
        


/***/ }),

/***/ 71409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionByHandler"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCollectionSortKeys"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reverse"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductFilter"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionsProductFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":348}};
    doc.loc.source = {"body":"#import './CollectionFragment.gql'\n#import './CollectionProductFragment.gql'\n\nquery CollectionByHandler(\n  $handle: String!,\n  $first: Int,\n  $sortKey: ProductCollectionSortKeys,\n  $after: String,\n  $reverse: Boolean\n  $filters: [ProductFilter!]\n) {\n  collection(handle: $handle) {\n    ...CollectionFragment\n    ...CollectionsProductFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(48847).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(19053).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.CollectionByHandler = oneQuery(doc, "CollectionByHandler");
        


/***/ }),

/***/ 16678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65186);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_scroll_handler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73865);





var BackTop = function(props) {
    var _num = props.num, num = _num === void 0 ? 0 : _num, _max = props.max, max = _max === void 0 ? 1600 : _max, _className = props.className, className = _className === void 0 ? '' : _className;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref1[0], setShow = ref1[1];
    var throttleFunc = lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        var // @ts-ignore
        ref;
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        setShow(scrollTop >= max);
        (ref = document.querySelector('.udesk-client-btn')) === null || ref === void 0 ? void 0 : ref.style.transform = "translateY(-".concat(scrollTop >= max ? 4 : 0, "rem)");
    }, 500);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener('scroll', throttleFunc);
        return function() {
            window.removeEventListener('scroll', throttleFunc);
        };
    }, []);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: function() {
            return (0,_utils_scroll_handler__WEBPACK_IMPORTED_MODULE_3__/* .scrollAnimation */ .QB)(num, 0);
        },
        className: "cursor-pointer z-20 w-11 h-11 bg-black rounded-1/2 flex items-center justify-center fixed bottom-10 right-4 md:right-8 md:bottom-14 rounded-full transform-gpu transition-opacity ".concat(show ? 'opacity-100' : 'opacity-0', " ").concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdArrowUpward */ .InZ, {
            color: "#fff",
            size: "26"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BackTop);


/***/ }),

/***/ 45760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(951);



var Loading = function(props) {
    var _className = props.className, className = _className === void 0 ? '' : _className, _size = props.size, size = _size === void 0 ? 40 : _size, _color = props.color, color = _color === void 0 ? '#999999' : _color;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex justify-center items-center ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "animate-spin inline-block m-auto",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_2__/* .AiOutlineLoading */ .xz6, {
                size: size,
                color: color
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 89096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xn": function() { return /* binding */ CollectionSkeleton; },
/* harmony export */   "LR": function() { return /* binding */ PagesSkeleton; },
/* harmony export */   "NB": function() { return /* binding */ ProductSkeleton; }
/* harmony export */ });
/* unused harmony export ProductItem */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74782);

/* eslint-disable import/prefer-default-export */ 

var ProductItem = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        animate: false,
        viewBox: "0 0 330 510",
        backgroundColor: "#f3f3f3",
        foregroundColor: "#f3f3f3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0",
                y: "0",
                width: "330",
                height: "440"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0",
                y: 450,
                width: "330",
                height: "18"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0",
                y: 450 + 18 + 10,
                width: "150",
                height: "26"
            })
        ]
    });
};
var CollectionSkeleton = function(param) {
    var className = param.className, _count = param.count, count = _count === void 0 ? 8 : _count;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "grid grid-cols-2 md:grid-cols-4 -mx-2 ".concat(className),
        children: Array(count).fill(0).map(function(_, idx) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-2 mb-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductItem, {
                })
            }, idx);
        })
    });
};
var PagesSkeleton = function(param) {
    var _isPC = param.isPC, isPC = _isPC === void 0 ? false : _isPC;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        rtl: true,
        speed: 2,
        className: "w-full h-full",
        viewBox: "0 0 ".concat(isPC ? '1065 1008' : '686 850'),
        backgroundColor: "#f3f3f3",
        children: isPC ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 0 64 h 1065 v 16 H 0 z M 0 448 h 1065 v 16 H 0 z M 0 832 h 1065 v 16 H 0 z M 0 152 h 1065 v 16 H 0 z M 0 536 h 1065 v 16 H 0 z M 0 920 h 1065 v 16 H 0 z M 0 88 h 1065 v 16 H 0 z M 0 472 h 1065 v 16 H 0 z M 0 856 h 1065 v 16 H 0 z M 0 176 h 1065 v 16 H 0 z M 0 560 h 1065 v 16 H 0 z M 0 944 h 1065 v 16 H 0 z M 0 200 h 1065 v 16 H 0 z M 0 584 h 1065 v 16 H 0 z M 0 968 h 1065 v 16 H 0 z M 0 264 h 1065 v 160 H 0 z M 0 648 h 1065 v 160 H 0 z M 0 112 h 817 v 16 H 0 z M 0 496 h 817 v 16 H 0 z M 0 880 h 817 v 16 H 0 z M 0 224 h 560 v 16 H 0 z M 0 608 h 560 v 16 H 0 z M 0 992 h 560 v 16 H 0 z M 232 0 h 600 v 32 H 232 z"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 136 0 h 414 v 56 H 136 z M 0 100 h 686 v 42 H 0 z M 0 412 h 349 v 42 H 0 z M 0 578 h 349 v 42 H 0 z M 0 163 h 686 v 209 H 0 z M 0 475 h 686 v 19 H 0 z M 0 515 h 686 v 19 H 0 z M 0 641 h 686 v 209 H 0 z"
        })
    });
};
var ProductSkeleton = function(param) {
    var _isPC = param.isPC, isPC = _isPC === void 0 ? false : _isPC;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        // speed={2}
        animate: false,
        className: "w-full h-full",
        viewBox: "0 0 ".concat(isPC ? '1408 911' : '750 1316'),
        backgroundColor: "#f3f3f3",
        foregroundColor: "#f3f3f3",
        children: isPC ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 94 0 h 685 v 911 H 94 z M 0 114 h 71 v 96 H 0 z M 0 226 h 71 v 96 H 0 z M 0 338 h 71 v 96 H 0 z M 0 0 h 71 v 96 H 0 z M 854 14 h 552 v 24 H 854 z M 854 53 h 165 v 24 H 854 z M 854 94 h 165 v 24 H 854 z M 854 181 h 165 v 24 H 854 z M 1294 181 h 112 v 24 h -112 z M 854 124 h 370 v 40 H 854 z M 854 210 h 552 v 36 H 854 z M 854 258 h 552 v 62 H 854 z M 854 353 h 552 v 152 H 854 z M 854 530 h 552 v 44 H 854 z M 854 592 h 552 v 148 H 854 z M 854 754 h 552 v 110 H 854 z"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 0 0 h 82 v 773 H 0 z M 90 0 h 570 v 773 H 90 z M 668 0 h 82 v 773 h -82 z M 24 793 h 450 v 40 H 24 z M 684 793 h 42 v 40 h -42 z M 24 853 h 179 v 52 H 24 z M 24 932 h 179 v 28 H 24 z M 493 862 h 233 v 28 H 493 z M 549 1067 h 177 v 28 H 549 z M 24 1067 h 104 v 28 H 24 z M 24 975 h 570 v 64 H 24 z M 24 1111 h 702 v 64 H 24 z M 24 1182 h 702 v 134 H 24 z"
        })
    });
};


/***/ }),

/***/ 31320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useGetCollectionsByHandler; },
/* harmony export */   "a": function() { return /* binding */ useCollectionQuery; }
/* harmony export */ });
/* harmony import */ var _root_workspace_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92021);
/* harmony import */ var _root_workspace_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_workspace_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56675);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3842);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(24432);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var _types_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35312);
/* harmony import */ var _types_storefront__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1182);
/* harmony import */ var _api_graphql_collectionHandlerQuery_gql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71409);
/* harmony import */ var _api_graphql_collectionHandlerQuery_gql__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_api_graphql_collectionHandlerQuery_gql__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52372);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37336);
/* harmony import */ var _utils_scroll_handler__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73865);
/* harmony import */ var _utils_query_parser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21783);

/* eslint-disable import/prefer-default-export */ 









function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function useGetCollectionsByHandler(initialState) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var client = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_10__/* .useApolloClient */ .x)();
    var routerQuery = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var _query = router.query, handle = _query.handle, sortBy = _query.sort_by;
        return {
            handle: handle,
            sortBy: sortBy
        };
    }, [
        router.query
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), staticData = ref4[0], setStatic = ref4[1];
    var ref1 = _slicedToArray((typeof routerQuery.handle === 'string' ? [
        routerQuery.handle
    ] : routerQuery.handle) || [], 1), collection = ref1[0];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        handle: collection,
        sortKey: _types_storefront__WEBPACK_IMPORTED_MODULE_4__/* .ProductCollectionSortKeys.CollectionDefault */ .s6.CollectionDefault,
        reverse: false,
        first: 24
    }), variables = ref2[0], setVariables = ref2[1];
    // Query in shopify
    var ref3 = _slicedToArray((0,_apollo_client__WEBPACK_IMPORTED_MODULE_11__/* .useLazyQuery */ .t)((_api_graphql_collectionHandlerQuery_gql__WEBPACK_IMPORTED_MODULE_5___default()), {
        notifyOnNetworkStatusChange: true
    }), 2), getCollection = ref3[0], query = ref3[1];
    var data = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        var collectionData = (ref = query.data) === null || ref === void 0 ? void 0 : ref.collection;
        // const collectionData =
        //   !variables.filters &&
        //   variables.sortKey === ProductCollectionSortKeys.CollectionDefault
        //     ? staticData?.collection
        //     : query.data?.collection
        // @ts-ignore
        return {
            collection: collectionData,
            products: collectionData === null || collectionData === void 0 ? void 0 : collectionData.products
        };
    }, [
        query
    ]);
    // Collection filters
    /**
   * filtersmap
   * { key(lower case): Filter }
   */ var filtersMap = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        return data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.filters.filter(function(i) {
            return i.label !== 'Availability';
        }).reduce(function(acc, i) {
            acc[i.label.replace(/\s/, '_').toLowerCase()] = i;
            return acc;
        }, {
        });
    }, [
        data.products
    ]);
    var collectionCount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref, ref5, ref6;
        return ((ref6 = (ref5 = data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.filters.find(function(i) {
            return i.label === 'Availability';
        })) === null || ref5 === void 0 ? void 0 : ref5.values.find(function(i) {
            return i.label === 'In stock';
        })) === null || ref6 === void 0 ? void 0 : ref6.count) || 0;
    }, [
        data
    ]);
    var fetchGqlMore = function() {
        var ref, ref7;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage)) return;
        var cursor = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getCursors */ .EH)(data.products.edges);
        if (!cursor) return;
        (ref7 = query.fetchMore) === null || ref7 === void 0 ? void 0 : ref7.call(query, {
            variables: _objectSpread({
            }, variables, {
                after: cursor
            })
        });
    };
    var fetchStaticMore = _asyncToGenerator(_root_workspace_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, cursor, res, json;
        return _root_workspace_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    cursor = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getCursors */ .EH)(data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.edges);
                    if (cursor) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 4:
                    _ctx.next = 6;
                    return fetch("/_next/data/".concat("Va_T-AKG4u_T4yvd4gV6A", "/collection/").concat(collection, "/").concat(cursor, ".json"));
                case 6:
                    res = _ctx.sent;
                    _ctx.next = 9;
                    return res.json();
                case 9:
                    json = _ctx.sent;
                    client.writeQuery({
                        query: (_api_graphql_collectionHandlerQuery_gql__WEBPACK_IMPORTED_MODULE_5___default()),
                        variables: _objectSpread({
                        }, variables, {
                            after: cursor
                        }),
                        data: {
                            collection: json.pageProps
                        }
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    var fetchMore = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return !variables.filters && variables.sortKey === _types_storefront__WEBPACK_IMPORTED_MODULE_4__/* .ProductCollectionSortKeys.CollectionDefault */ .s6.CollectionDefault ? fetchStaticMore : fetchGqlMore;
    }, [
        data,
        variables
    ]);
    /**
   * Selected sort filter
   */ var sortItem = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!routerQuery.sortBy) return _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .CollectionSortList[0] */ .W6[0];
        return _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .CollectionSortList.find */ .W6.find(function(i) {
            return i.searchValue === routerQuery.sortBy;
        });
    }, [
        routerQuery
    ]);
    /**
   * Product filter map in router
   */ var productFilters = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var params = (0,_utils_query_parser__WEBPACK_IMPORTED_MODULE_9__/* .parseQueryToFilter */ .wS)(router.query).map(function(i) {
            return JSON.parse(i.input);
        }).flat();
        var extra = (0,_utils_query_parser__WEBPACK_IMPORTED_MODULE_9__/* .parseQueryToFilterParams */ .D7)(router.query);
        return params.concat(extra);
    }, [
        router.query
    ]);
    var updateVars = function() {
        var vars = _objectSpread({
        }, variables, {
            handle: collection
        });
        // Set sort options
        var ref = sortItem || {
        }, value = ref.value, reverse = ref.reverse;
        if (value) vars.sortKey = value;
        vars.reverse = reverse || false;
        vars.filters = productFilters;
        if (!productFilters.length) vars.filters = undefined;
        setVariables(_objectSpread({
        }, vars));
    };
    /**
   * Check is static requet
   * if not filters or sortkey, request data from static
   */ var isStaticRequest = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (false) {}
        var s = window.location.search;
        return !Object.values(_types_product__WEBPACK_IMPORTED_MODULE_3__/* .ProductFilterKeys */ .Tl).some(function(v) {
            return s.includes(v);
        }) && (s.indexOf('sort_by') < 0 || s.indexOf('sort_by=manual') >= 0);
    }, [
        router.query
    ]);
    /**
   * static props render dispatcher
   */ var dispatchInitialQuery = function(force) {
        var ref;
        if (!variables.handle) return;
        var prev = query.previousData;
        if (force || !prev || ((ref = prev.collection) === null || ref === void 0 ? void 0 : ref.handle) !== (initialState === null || initialState === void 0 ? void 0 : initialState.handle)) {
            client.writeQuery({
                query: (_api_graphql_collectionHandlerQuery_gql__WEBPACK_IMPORTED_MODULE_5___default()),
                variables: variables,
                data: {
                    collection: initialState
                },
                broadcast: true,
                overwrite: true
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!variables.handle || query.loading) return;
        if (isStaticRequest) {
            if (!router.isFallback && initialState) {
                var ref;
                var isBack = ((ref = _utils_scroll_handler__WEBPACK_IMPORTED_MODULE_8__/* .routeHistory */ .A$[_utils_scroll_handler__WEBPACK_IMPORTED_MODULE_8__/* .routeHistory.length */ .A$.length - 1]) === null || ref === void 0 ? void 0 : ref.pathname.indexOf('/collections')) < 0;
                if (!isBack) dispatchInitialQuery();
                if (!query.called) getCollection({
                    variables: variables
                });
                return;
            }
        }
        if (!isStaticRequest && !variables.filters && variables.sortKey === _types_storefront__WEBPACK_IMPORTED_MODULE_4__/* .ProductCollectionSortKeys.CollectionDefault */ .s6.CollectionDefault) {
            return;
        }
        // Get data from network query
        if (query.refetch && typeof query.data !== 'undefined') {
            query.refetch(variables);
        } else {
            getCollection({
                variables: variables
            });
        }
    }, [
        variables,
        router.isFallback
    ]);
    // Initial
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // dispatchInitialQuery()
        updateVars();
    }, [
        JSON.stringify(sortItem),
        JSON.stringify(productFilters)
    ]);
    return {
        sortItem: sortItem,
        dispatchInitialQuery: dispatchInitialQuery,
        getCollection: getCollection,
        variables: variables,
        query: query,
        fetchMore: fetchMore,
        data: data,
        filtersMap: filtersMap,
        setVariables: setVariables,
        staticData: staticData,
        setStatic: setStatic,
        collectionCount: collectionCount,
        isStaticRequest: isStaticRequest
    };
}
function useCollectionQuery(options) {
    var query = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_12__/* .useQuery */ .a)((_api_graphql_collectionHandlerQuery_gql__WEBPACK_IMPORTED_MODULE_5___default()), {
        variables: options.variables
    });
    return _objectSpread({
    }, query);
}


/***/ })

}]);